var map = {
	"./events-cat.webp": 2133,
	"./games-cat.webp": 2134,
	"./live-casino-cat.webp": 2135,
	"./lottery-cat.webp": 2136,
	"./other-cat.webp": 2137,
	"./p2p-cat.webp": 2138,
	"./pd-table.webp": 2139,
	"./privacy-policy-title-bm.webp": 2140,
	"./privacy-policy-title-cn.webp": 2141,
	"./privacy-policy-title-id.webp": 2142,
	"./privacy-policy-title.webp": 2143,
	"./promos-1.webp": 2144,
	"./promos-2.webp": 2145,
	"./promos-3.webp": 2146,
	"./promos-4.webp": 2147,
	"./question.webp": 2148,
	"./sideBar-bg.webp": 2149,
	"./slot-cat.webp": 2150,
	"./special-cat.webp": 2151,
	"./sports-cat.webp": 2152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 473;